module.exports = __webpack_public_path__ + "img/hiring-desktop-skeleton.8e987e96.png";